<script setup lang="ts">
import { Link, usePage } from '@inertiajs/vue3';
import { Zap } from 'lucide-vue-next';
import { computed } from 'vue';
import { index as billingIndex } from '@/routes/billing';

defineProps<{ compact?: boolean }>();

const page = usePage();
const credits = computed<number>(() => (page.props.credits as number) ?? 0);
</script>

<template>
    <Link
        :href="billingIndex().url"
        class="group inline-flex items-center gap-2 rounded-full border border-border/80 bg-card/60 px-3 py-1.5 text-xs font-medium backdrop-blur transition hover:border-violet-400/40 hover:bg-card"
    >
        <span
            class="flex size-5 items-center justify-center rounded-full bg-gradient-to-br from-violet-500/30 to-cyan-500/30 text-violet-300"
        >
            <Zap class="size-3" />
        </span>
        <span class="font-display tabular-nums">{{ credits.toLocaleString() }}</span>
        <span v-if="!compact" class="text-muted-foreground">credits</span>
    </Link>
</template>
